var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"disabled":_vm.disabled,"type":_vm.buttonType}},[_c('div',{staticClass:"ButtonInner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }